import { Ajax } from'../helpers/ajax';

export class Goodhabitz {

	constructor(elem) {
		this.elem = elem;
		this.form = this.elem.querySelector('form') || '';

		if (this.form) {
			this.addEventListeners();
		}
	}

	addEventListeners() {
		this.form.addEventListener('submit', (event) => {
			this.submitForm(event);
		})
	}

	submitForm(event) {
		event.preventDefault();
		this.elem.classList.add('loading');

		const formAction = this.form.action;

		Ajax.POST(formAction, 'html').then((response) => {
			this.elem.innerHTML = response;
			this.elem.classList.remove('loading');
		})
	}


	static getSelector() {
		return '[data-goodhabitz]';
	}

}

